<!-- 联系方式 -->
<template>
  <div id="contact" >
    <div>
      <div class="pointOut" >必填</div>
      <van-cell-group>
        <van-field
          v-model="info.email"
          :error-message="validator.ErrMsg.email"
          label="邮箱"
          placeholder="请输入邮箱地址"
          input-align="right"
        >
        </van-field>
      </van-cell-group>
      <div class="pointOut" >选填</div>
      <van-cell-group>
        <van-field
          v-model="info.contactnumber"
          label="固定电话"
          placeholder="固定电话"
          input-align="right"
        >
        </van-field>
        <van-field
          v-model="info.mobile"
          label="联系电话"
          placeholder="联系电话"
          input-align="right"
        >
        </van-field>
        <van-field
          v-model="info.address"
          v-show="type==='coach'"
          label="住址"
          placeholder="住址"
          input-align="right"
        >
        </van-field>
      </van-cell-group>
      <van-button class="btn" v-if="!isRead || isAppend" size="large" @click="routerPush()" :disabled="loading">完成</van-button>
      <van-button class="btn" v-if="isRead && !isAppend" size="large" @click="updateInfo()" :disabled="loading">保存</van-button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import { getValidMembership } from '@/utils'
import Validator from '@/libs/validator'
import { checkPassport } from '@/libs/passport'
import { getMemberType, setRegisterInfo, getRegisterInfo, removeMemberType, removeRegisterInfo } from '@/libs/cookie-storage'
import { registCoach, registReferee, getMyCoach, getMyReferee, updateCoach, updateReferee, getSourceList } from '@/api/info'
import { Field, Popup, Picker, Button, Toast } from 'vant'

Vue.use(Field).use(Picker).use(Popup).use(Button).use(Toast)

export default {
  name: 'Experience',
  data() {
    return {
      type: null,
      isRead: false,
      isAppend: false,
      info: {
        email: '',
        contactnumber: '',
        mobile: '',
        address: ''
      },
      rules: {
        email: [{ required: true, message: '必填消息' }]
      },
      reset: '',
      loading: false
    }
  },
  created() {
    checkPassport()
    this.sourceList = getSourceList()
    const memberType = getMemberType()
    if (!memberType) return
    this.type = memberType.type
    const regInfo = getRegisterInfo()
    if (regInfo) {
      this.info = Object.assign(this.info, regInfo)
    }
    if (memberType.status === 2) {
      this.isRead = true
      if (this.type === 'coach') {
        this.getMyCoach()
      } else {
        this.getMyReferee()
      }
    }
    this.validMemberShip = getValidMembership()
    if(this.validMemberShip.membership && this.validMemberShip.membership.length > 0) {
      const obj = _.find(this.validMemberShip.membership, function (item) {
        return item.membershipTypeId === memberType.membershipTypeId
      })
      this.isAppend = !obj
      if (this.isAppend) {
        this.isRead = true
      }
    }
    this.validator = new Validator({
      rules: this.rules,
      data: this.info
    })
    this.reset = this.$route.query.reset
  },
  mounted() {
  },
  methods: {
    routerPush() {
      if (this.type === 'coach') {
        this.coachRegisterInfo()
      } else {
        this.refereeRegisterInfo()
      }
    },
    coachRegisterInfo() {
      this.loading = true
      this.validator.validate(this.info.email).then((reslove) => {
        const regInfo = Object.assign(getRegisterInfo(), this.info)
        setRegisterInfo(regInfo)
        let params = {
          profile: regInfo.profile,
          trueName: regInfo.trueName,
          gender: regInfo.gender,
          nationality: regInfo.nationality,
          birthday: moment(regInfo.birthday).format('YYYY-MM-DDTHH:mm:ss+0800'),
          certificateType: regInfo.certificateType==='身份证'? 1 : 2,
          certificateNum: regInfo.certificateNum,
          certificateFrontImg: regInfo.certificateFrontImg,
          certificateBackImg: regInfo.certificateBackImg,
          organizationId: regInfo.organization.id,
          email: regInfo.email,
          area: '北京-长期',
          high: regInfo.high,
          weight: regInfo.weight,
          educationLevel: regInfo.educationLevel,
          foreignLanguage: regInfo.foreignLanguage,
          coachingTeamName: regInfo.coachingTeamName,
          position: regInfo.position,
          preRetirementTeamNames: regInfo.preRetirementTeamNames,
          competitionPerformance: regInfo.competitionPerformance,
          exHirers: regInfo.exHirers,
          exCoachTeams: regInfo.exCoachTeams,
          certificateLevel: regInfo.certificateLevel,
          certificateIssuedBy: regInfo.certificateIssuedBy,
          coachingPerformance: regInfo.coachingPerformance,
          contactnumber: regInfo.contactnumber,
          mobile: regInfo.mobile,
          address: regInfo.address
        }
        if (regInfo.source === this.sourceList[3]) {
          params.source = regInfo.otherSource
        } else {
          params.source = regInfo.source
        }
        if (regInfo.id) {
          params.id = regInfo.id
          updateCoach(params).then((res) => {
            if (res) {
              Toast('完善信息成功')
              // removeMemberType()
              removeRegisterInfo()
              this.$router.push('review')
              this.loading = false
            }
          }, (reject) => {
            Toast('完善信息失败')
            this.loading = false
        })
        } else {
          registCoach(params).then((res) => {
            if (res) {
              Toast('完善信息成功')
              // removeMemberType()
              removeRegisterInfo()
              this.$router.push('review')
              this.loading = false
            }
          }, (reject) => {
            Toast('完善信息失败')
            this.loading = false
        })
        }
      }, (reject) => {
        Toast('请填写必要的信息')
        this.loading = false
      })
    },
    refereeRegisterInfo() {
      this.loading = true
      this.validator.validate(this.info.email).then((reslove) => {
        const regInfo = Object.assign(getRegisterInfo(), this.info)
        setRegisterInfo(regInfo)
        let refereeCertificateDate = regInfo.refereeCertificateDate
        if (refereeCertificateDate) {
          refereeCertificateDate = moment(refereeCertificateDate).format('YYYY-MM-DDTHH:mm:ss+0800')
        }
        let params = {
          profile: regInfo.profile,
          trueName: regInfo.trueName,
          gender: regInfo.gender,
          nationality: regInfo.nationality,
          birthday: moment(regInfo.birthday).format('YYYY-MM-DDTHH:mm:ss+0800'),
          certificateType: regInfo.certificateType === '身份证' ? 1 : 2, ///
          certificateNum: regInfo.certificateNum,
          certificateFrontImg: regInfo.certificateFrontImg,
          certificateBackImg: regInfo.certificateBackImg,
          inField: regInfo.inField === '是'? 1 : 0, ////
          email: regInfo.email,
          high: regInfo.high,
          weight: regInfo.weight,
          educationLevel: regInfo.educationLevel,
          foreignLanguage: regInfo.foreignLanguage,
          instructorLevel: regInfo.instructorLevel,
          refereeLevel: regInfo.refereeLevel,
          refereeCertificateNo: regInfo.refereeCertificateNo,
          refereeCertificateDate: refereeCertificateDate,
          employerOrganization: regInfo.employerOrganization,
          workplaceAddress: regInfo.workplaceAddress,
          athletePerformance: regInfo.athletePerformance,
          refereePerformance: regInfo.refereePerformance,
          contactnumber: regInfo.contactnumber,
          mobile: regInfo.mobile,
          address: regInfo.address
        }
        if (regInfo.source === this.sourceList[3]) {
          params.source = regInfo.otherSource
        } else {
          params.source = regInfo.source
        }
        if (regInfo.id) {
          params.id = regInfo.id
          updateReferee(params).then((res) => {
            if (res) {
              Toast('完善信息成功')
              removeMemberType()
              removeRegisterInfo()
              this.$router.push('review')
              this.loading = false
            }
          }, (reject) => {
            Toast('完善信息失败')
          this.loading = false
        })
        } else {
          registReferee(params).then((res) => {
            if (res) {
              Toast('完善信息成功')
              removeMemberType()
              removeRegisterInfo()
              this.$router.push('review')
              this.loading = false
            }
          }, (reject) => {
            Toast('完善信息失败')
          this.loading = false
        })
        }
      }, (reject) => {
        Toast('请填写必要的信息')
        this.loading = false
      })
    },

    getMyCoach() {
      getMyCoach().then(response => {
        const data = response.data
        if (data) {
          this.info = Object.assign(this.info, data.coach.user, data.coach)
        }
      })
    },
    getMyReferee() {
      getMyReferee().then(response => {
        const data = response.data
        if (data) {
          this.info = Object.assign(this.info, data.referee.user, data.referee)
        }
      })
    },
    updateInfo() {
      if (this.type === 'coach') {
        this.updateCoach()
      } else {
        this.updateReferee()
      }
    },
    updateCoach() {
      this.validator.validate(this.info.email).then((reslove) => {
        const params = {
          id: this.info.id,
          email: this.info.email,
          contactnumber: this.info.contactnumber,
          mobile: this.info.mobile,
          address: this.info.address
        }
        updateCoach(params).then(response => {
          const data = response.data
          if (data) {
            Toast('保存成功')
            if (this.reset==1) {
              this.$router.push({ path: 'review', query: {reset: 2} })
            } else {
              this.$router.push('ucenter')
            }
          }
        })
      }, (reject) => {
        Toast('请填写必要的信息')
      })
    },
    updateReferee() {
      this.validator.validate(this.info.email).then((reslove) => {
        const params = {
          id: this.info.id,
          email: this.info.email,
          contactnumber: this.info.contactnumber,
          mobile: this.info.mobile,
          address: this.info.address
        }
        updateReferee(params).then(response => {
          const data = response.data
          if (data) {
            Toast('保存成功')
            if (this.reset==1) {
              this.$router.push({ path: 'review', query: {reset: 2} })
            } else {
              this.$router.push('ucenter')
            }
          }
        })
      }, (reject) => {
        Toast('请填写必要的信息')
      })
    }
  },
  computed: {}
}
</script>
<style>
#contact {
  position: relative;
  height: 100%;
  background-color: white;
}

#contact .title {
  padding: 15px 15px;
  width: calc(100% - 30px);
  background-color: #bfcdd9;
  margin-top: 200px;
}

#contact .pointOut {
  padding: 0 15px;
  height: 40px;
  background-color: rgba(248,248,248,1);
  font-weight:400;
  color:rgba(129,129,129,1);
  line-height: 40px;
}

#contact .textarea h5 {
  margin: 0;
  font-size:16px;
  font-weight:400;
  color: #323233;
}

#contact .textarea textarea {
  border: none;
}

#contact .btn {
  height:60px;
  background: #185494;
  border-radius:2px;
  border: none;
  font-weight:400;
  color: white;
  font-size:20px;
  position: absolute;
  bottom: 30px;
}

#contact .van-cell:not(:last-child)::after {
  border-bottom: none;
}

#contact .van-hairline--top-bottom::after {
  border-width: 0;
}

#contact .van-cell {
  font-size: 16px;
  padding: 20px 15px;
  border-bottom: 1px solid #F2F2F2;
}

</style>



// WEBPACK FOOTER //
// src/pages/auth/contact-information.vue